import { render, staticRenderFns } from "./DocumentsComponent.vue?vue&type=template&id=78a91258&"
import script from "./DocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports